﻿<template>
    <section>
        <b-field>
            <b-radio-button
                v-if="!hideNull"
                v-model="local"
                native-value="null"
                :disabled="disabled"
                :size="size"
                type="is-light">
                <b-icon
                    icon="minus" />
                <span>No Value</span>
            </b-radio-button>

            <b-radio-button
                v-model="local"
                :size="size"
                :disabled="disabled"
                native-value="false"
                type="is-danger">
                <b-icon icon="close" />
                <span>False</span>
            </b-radio-button>
            <b-radio-button
                v-model="local"
                :disabled="disabled"
                native-value="true"
                :size="size"
                type="is-info">
                <b-icon icon="check" />
                <span>True</span>
            </b-radio-button>
        </b-field>
    </section>
</template>

<script lang="ts" setup>
    import { ref, watch } from 'vue';
    const props = withDefaults(defineProps<{
        modelValue: unknown;
        hideNull?: boolean;
        size?: string;
        disabled?: boolean;
    }>(), ({
        disabled: false,
        hideNull: true,
        size: ''
    }));

    const local = ref<string>(parseModelValue(props.modelValue));

    const emit = defineEmits<{
        (_e: 'update:modelValue', _payload: boolean | null): void;
    }>();

    function parseModelValue(v: unknown): string {
        if (typeof v === 'string') {
            return v;
        } else if (typeof v === 'boolean') {
            if (v) {
                return 'true';
            } else {
                return 'false';
            }
        } else if (v === null) {
            return 'null';
        }
        throw new Error('failed to parse bool string');
    }

    function parseLocalValue(v: string): boolean | null {
        if (v === 'true') {
            return true;
        } else if (v === 'false') {
            return false;
        }
        return null;
    }

    watch(local, (newValue) => {
        emit('update:modelValue', parseLocalValue(newValue));
    });

    watch(() => props.modelValue, (newValue) => {
        local.value = parseModelValue(newValue);
    });

</script>

<style scoped>
:deep([disabled].radio.is-info) {
    color: white; /* Otherwise it's gray and unreadable */
}
</style>
